function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function () {
  'use strict';

  /* Directives */
  angular.module('wsLrs.directives').
  /* this directive can be used in any reporting context to let the user know if no data was found,
  * or that data is still being loaded. If the QueryWithProgress service is used, and publishes events
  * on the given progress channel, progress can be shown as it is received during reporting.
  *
  * hasData: true if the card found any data to show, otherwise false if no data found.
  *     (NOTE: "hasData" has to be undefined or null while card is loading.)
  * card: the card associated with this report
  * cardId: optional method for specifying the card associated with this report
  * progressChannel: an ID that specifies the progress events for this directive to listen for
  */

  directive('wsReportLoading', ['CardRegistry', '$timeout', '$location', 'QueryES', 'Logger', function wsReportLoading(CardRegistry, $timeout, $location, QueryES, Logger) {
    return {
      scope: {
        hasData: "=",
        card: "&?",
        cardId: "&?",
        progressChannel: "&?",
        noDataMsg: "=?",
        delay: '&?'
      },
      templateUrl: "modules/common/directives/report-loading/report-loading.html",
      link: function link(scope) {
        if (!scope.noDataMsg) {
          scope.noDataMsg = "This report has no data";
          if ($location.search().filter) {
            scope.noDataMsg = 'The selected filters do not have any data';
          }
        }

        // One time, one way binding of card, cardId, progressChannel
        scope.card = _.isFunction(scope.card) ? scope.card() : undefined;
        scope.cardId = _.isFunction(scope.cardId) ? scope.cardId() : undefined;
        scope.progressChannel = _.isFunction(scope.progressChannel) ? scope.progressChannel() : undefined;
        if (!scope.card && scope.cardId) {
          scope.card = CardRegistry.get(scope.cardId);
        }

        // Show progress loading only after a short delay
        scope.longWait = false;
        $timeout(function () {
          if (typeof scope.hasData === "undefined" || scope.hasData === null) {
            scope.longWait = true;
          }
        }, scope.delay || 2000);
        var progressAvailable = true;

        // We must listen for progress on a particular "channel", if we aren't doing
        // so, force the use of non progress loading visual
        if (!scope.progressChannel) {
          progressAvailable = false;
        }

        // IE8 and IE9 can't show progress, so force use of spinner
        var $html = $("html");
        if ($html.hasClass("ie8") || $html.hasClass("ie9")) {
          progressAvailable = false;
        }

        // If we're not able to discover or show progress, skip the event handlers
        if (!progressAvailable) {
          return;
        }

        // Set up progress event listeners on the given progress channel
        var progressEventPrefix = "report-progress:" + scope.progressChannel,
          progressEventName = progressEventPrefix + ":progress",
          errorEventName = progressEventPrefix + ":error";
        scope.progress = null;
        scope.error = null;
        scope.$on(progressEventName, function (evt, progress) {
          scope.progress = progress;
        });
        function isSimpleTooMuchDataError(reason) {
          return typeof reason === "string" && reason.indexOf("too large") > -1;
        }
        function isDetailedTooMuchdataError(reason) {
          return typeof reason === "string" && /^\d+ is over the maximum statement limit/.test(reason);
        }
        function isElasticsearchTimeoutError(reason) {
          return typeof reason === "string" && /ElasticsearchTimeoutException/.test(reason);
        }
        function makeElasticsearchTimeoutMessage() {
          return "Something went wrong while loading report data. " + "Click the 'clear cache' link below to try again.";
        }
        function isTimeoutError(reason) {
          return typeof reason === "string" && reason.indexOf("timed out") > -1;
        }
        scope.$on(errorEventName, function (evt, reason) {
          scope.error = reason;
          if (isTimeoutError(reason)) {
            scope.noDataMsg = "<span title='Report Timed Out'>Report Data Unavailable\n\n" + "The amount of data needed to run this report may be too large.</span>";
          } else if (isElasticsearchTimeoutError(reason)) {
            scope.noDataMsg = makeElasticsearchTimeoutMessage();
          } else if (isSimpleTooMuchDataError(reason)) {
            scope.noDataMsg = "Report Data Unavailable\n\n" + "The amount of data needed to run this report is too large.";
          } else if (isDetailedTooMuchdataError(reason)) {
            scope.noDataMsg = reason;
          } else {
            try {
              Logger.debug("Type of reason was: ".concat(_typeof(reason), " with value: ").concat(JSON.stringify(reason)));
            } catch (e) {
              // This may happen if reason happens to be an Angular $scope object with infinite recursion
              // This code should eventually be removed once we understand what the "reason" object looks like,
              // but for now its very intermittent so we just want lots of logging.
              Logger.debug("Error while trying to print out other error. Error was: ", e);
            }
          }
        });
      }
    };
  }]);
})();
